import { NotesInfoText, NotesLabel, StaticComponentGrid } from "../../LeadDetails.styles.ts";
import { LeadNotesLabel, LeadStatusLabel, OrderNumberLabel } from "../../LeadDetails.text.ts";
import { UnavailableDataPlaceholderText } from "constants/text.ts";
import { components } from "types/declarations/api";
import LabeledField from "features/LeadGen/pages/LeadDetails/components/LabeledField/LabeledField.tsx";

interface LeadDetailsTrackingInformationReadOnlyProps {
	assignmentDetails?: components["schemas"]["LeadAssignmentViewModel"];
}

const LeadDetailsTrackingInformationReadOnly = ({ assignmentDetails }: LeadDetailsTrackingInformationReadOnlyProps) => {
	return (
		<>
			<StaticComponentGrid>
				<LabeledField
					label={LeadStatusLabel}
					value={assignmentDetails?.status}
					dataTestId="lead-details-status-label"
				/>
				<LabeledField
					label={OrderNumberLabel}
					value={assignmentDetails?.orderNumber?.trim()}
					dataTestId="lead-details-order-number-label"
				/>
			</StaticComponentGrid>
			<NotesLabel>
				{LeadNotesLabel}
				<NotesInfoText data-testid="lead-details-notes-label">
					{assignmentDetails?.leadAssignmentNotes || UnavailableDataPlaceholderText}
				</NotesInfoText>
			</NotesLabel>
		</>
	);
};

export default LeadDetailsTrackingInformationReadOnly;
